import React from 'react';
import { Combo } from 'fw/forms';

class StatusFilter extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = this.initialState();
    }

    initialState = () => {
        return {
            items: [
                { label: "Active " + this.props.entity, value: true },
                { label: "Inactive  " + this.props.entity, value: false },
                { label: "All " + this.props.entity, value: null }
            ]
        }
    }

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                clearable={false}
                searchable={false} />
        )
    }
}

export default StatusFilter;

// Mark this as a form component
StatusFilter.defaultProps = {
	formControl: true,
	managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/statusFilter/StatusFilter.js